import React from 'react';

import {FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';


export const AccountTeamMemberSettingsSkeleton = () => (
    <FormSectionSkeleton labelWidth={313}>
        <Item style={{width: 200}} grow={1}>
            <Group alignItems="center" justify="space-between">
                <SkeletonItem width={140} height={16}/>
                <SkeletonItem width={30} height={16}/>
            </Group>
        </Item>
    </FormSectionSkeleton>
);
